import classNames from 'classnames'
import { ListItem, Skeleton } from '@/tools/ui'
import styles from '@/tools/ui/components/item-row/ItemRow.module.scss'

export const ItemRowSkeleton = () => {
  const leadingContent = (
    <Skeleton animated>
      <svg
        className={classNames('pintxo-skeleton-shape')}
        height="112"
        width="112"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect height="100%" rx={10} ry={10} width="100%" x="0" y="0" />
      </svg>
    </Skeleton>
  )
  return (
    <div className={styles.itemRow}>
      <ListItem className={styles.itemRowListItem} leadingContent={leadingContent}>
        <div className={styles.itemRowBody}>
          <div className={styles.headerContainer}>
            <div className={styles.titleContainer}>
              <Skeleton animated>
                <svg
                  className={classNames('pintxo-skeleton-shape')}
                  height={24}
                  width={140}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect height={'100%'} rx={10} ry={10} width={'100%'} />
                </svg>
              </Skeleton>
            </div>
          </div>
          <Skeleton animated>
            <svg
              className={classNames('pintxo-skeleton-shape')}
              height={24}
              width={340}
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect height={'100%'} rx={10} ry={10} width={'100%'} />
            </svg>
          </Skeleton>
        </div>
      </ListItem>
    </div>
  )
}
